import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { LoaderService } from "src/app/shared/services/loader.service";

@Component({
  standalone: true,
    selector: "app-loader",
    templateUrl: "./loader.component.html",
    styleUrls: ["./loader.component.scss"],
    imports: [CommonModule, TranslateModule]
})
export class LoaderComponent {
  test = "custom-loader-wrapper blur-bg";

  constructor(private _loaderService: LoaderService) {}

  show = this._loaderService.loading;
}
